export const AvailableAgents = [
    {
        agentId: 'advice_agent_samsung_tvs',
        chatSource: 'bram',
    },
    {
        agentId: 'advice_agent_apple_macbooks',
        chatSource: 'catherine',
    },
    {
        agentId: 'advice_agent_miele_washingmachines',
        chatSource: 'axel',
    },
    {
        agentId: 'advice_agent_lenovo_laptops',
        chatSource: 'matt',
    },
    {
        agentId: 'contact_options_agent',
        chatSource: '',
    },
    {
        agentId: 'order_status_agent',
        chatSource: '',
    },
    {
        agentId: 'qa_agent',
        chatSource: '',
    },
    {
        agentId: 'welcome_agent',
        chatSource: '',
    },
];
//# sourceMappingURL=AvailableAgents.js.map